import React, { useState,useEffect,useContext } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso,ColumDataTableReorganize,FormatedPrice,ExportArticleButton,AddMarkExportForm,useLocalStorage} from '@gull'
import axios from 'axios';
import swal from "sweetalert2";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { useCookies} from 'react-cookie';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { espace_mille } from 'app/espace_mille';
import { IsAuthContext } from 'app/App';

const useLoad = (props) =>{
    const t = useTranslate();
    const [allDocuments,setAllDocuments] = useState([]) 
    const [sizeDatas,setSizeDatas]=useState(0)

    useEffect(function () {
        (async function() {
            const response = await axios.post(process.env.REACT_APP_API_URL+"api/facture/invoice/get_all_ecotaxe", props.exportParam
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{   
                    setAllDocuments(response.data.datas)
                    setSizeDatas(response.data.count)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
        })()
    }, [props.reload])

    return [allDocuments,sizeDatas]
}

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            pagination={paginationFactory(props.paginationOptions)}
            noDataIndication={t('tableNoData')}
            rowStyle={ props.rowStyle }
            onTableChange={ props.handleTableChange }
            wrapperClasses="no-sticky"//Ajouter cette class permet de d'éviter d'avoir le style sticky sur la première colonne du datatable pour certain datable qui n'ont pas de colonne action
            hover
            condensed
            responsive
        />
    );
};

const EcotaxeDataTable = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [addMark,setAddMark]=useState(true) 
    const [cookies, setCookie] = useCookies(['search_billing_ecotaxe_table_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['search_billing_ecotaxe_table_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.search_billing_ecotaxe_table_reorganize && cookies.search_billing_ecotaxe_table_reorganize){
            setLocalStorage('search_billing_ecotaxe_table_reorganize',cookies.search_billing_ecotaxe_table_reorganize);
        }
    }, []);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    const [lang, setLang] = useCookies(['lang']);

    const [allDocuments,sizeDatas] = useLoad(props)

    const [perPage,setPerPage] = useState(50)
    const [currentPage,setCurrentPage] = useState(1)
    
    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    let devise = authParam.company.devise;
    let digit = (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    let dataTable = new Array
    allDocuments.length!=0 && allDocuments.map((value,ind)=>{
        let obj = {
            tranche: <FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ecotaxe_unitaire} />,
            amount: <FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.total} />,
            nb_articles: espace_mille(value.total_quantity,digit),
            index: ind + 1,
        }
        dataTable.push(obj)
    })

    let columns = [
        {
            dataField: "tranche",
            text: t('perSlice'),
            editable: false,
            // sort: true,
        },
        {
            dataField: "amount",
            text: t('amount'),
            editable: false,
            // sort: true,
        },
        {
            dataField: "nb_articles",
            text: t('itemsNumber'),
            editable: false,
            sort: true,
        },
    ];

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.search_billing_ecotaxe_table_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.search_billing_ecotaxe_table_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage('search_billing_ecotaxe_table_reorganize',arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        page:currentPage,
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: sizeDatas,
    };

    const rowStyle = (row) => {
        const style = {};

        if(row.status==t('canceled')) {
            style.backgroundColor = '#fccfcf';//annulé
        }
        else if(row.finalise){
            style.backgroundColor = '#d9fcd2';//finalisé
        }
        else if(row.status==t('notCompleted')){
            style.backgroundColor = '#ffffbb';
        }
        
        return style;
    };

    return (
        <div>
            <CardPerso>
                {columnOrganize.length!=0 &&
                    <small>
                        <ToolkitProvider
                            keyField="index"
                            data={dataTable}
                            columns={columnOrganize}
                        >
                        {(propst) => (
                            <>
                                <div className="d-flex align-items-baseline mb-3">
                                    <ColumDataTableReorganize 
                                        columnOrganize={columnOrganize}
                                        setColumnOrganize={setColumnOrganize}
                                        setCookie={setLocalStorage}
                                        cookieName='search_billing_ecotaxe_table_reorganize'
                                        showColumnOrganize={showColumnOrganize}
                                        setShowColumnOrganize={setShowColumnOrganize}
                                        btnSwitch={false}//pour affiche ou non le btn swith
                                        initSwith={true}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                    />&nbsp;&nbsp;&nbsp;
                                    <span className='d-flex'>
                                        <ExportArticleButton lang={lang.lang} addMark={addMark} filtre={props.exportParam} header={[]} title={t('downloadCSVecotaxe')} type="button" url={"api/facture/invoice/export_ecotaxe"}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                        <ExportArticleButton lang={lang.lang} addMark={addMark} filtre={props.exportParam} header='all' title={t('downloadCSVecotaxeDetail')} type="button" url={"api/facture/invoice/export_ecotaxe_detail"}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                        <AddMarkExportForm setAddMark={setAddMark} addMark={addMark} />
                                    </span>
                                </div>
                                <div className="position-relative">
                                    <CustomDataTable 
                                        propst={propst}
                                        paginationOptions={paginationOptions}
                                        rowStyle={rowStyle}
                                        columns={columns}
                                    />
                                </div>
                            </>
                        )}
                        </ToolkitProvider>
                    </small>
                }
            </CardPerso>
        </div>
    )
};

export default EcotaxeDataTable;